/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.apibuffers.BasicUserInfo', null, global);
goog.exportSymbol('proto.apibuffers.CountryCode', null, global);
goog.exportSymbol('proto.apibuffers.Date', null, global);
goog.exportSymbol('proto.apibuffers.DateRange', null, global);
goog.exportSymbol('proto.apibuffers.Decimal', null, global);
goog.exportSymbol('proto.apibuffers.DeviceInfo', null, global);
goog.exportSymbol('proto.apibuffers.DeviceInfo.DeviceType', null, global);
goog.exportSymbol('proto.apibuffers.Dimension', null, global);
goog.exportSymbol('proto.apibuffers.Distance', null, global);
goog.exportSymbol('proto.apibuffers.Distance.DistanceType', null, global);
goog.exportSymbol('proto.apibuffers.ExtendedUserInfo', null, global);
goog.exportSymbol('proto.apibuffers.ExtendedUserInfo.OnlineStatus', null, global);
goog.exportSymbol('proto.apibuffers.FriendshipStatus', null, global);
goog.exportSymbol('proto.apibuffers.Image', null, global);
goog.exportSymbol('proto.apibuffers.Image.Class', null, global);
goog.exportSymbol('proto.apibuffers.LatLong', null, global);
goog.exportSymbol('proto.apibuffers.Location', null, global);
goog.exportSymbol('proto.apibuffers.LocationCircle', null, global);
goog.exportSymbol('proto.apibuffers.LocationUpdate', null, global);
goog.exportSymbol('proto.apibuffers.Lottie', null, global);
goog.exportSymbol('proto.apibuffers.Media', null, global);
goog.exportSymbol('proto.apibuffers.UserError', null, global);
goog.exportSymbol('proto.apibuffers.Video', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.DeviceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.DeviceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.DeviceInfo.displayName = 'proto.apibuffers.DeviceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.LatLong = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.LatLong, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.LatLong.displayName = 'proto.apibuffers.LatLong';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Distance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Distance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Distance.displayName = 'proto.apibuffers.Distance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.LocationCircle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.LocationCircle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.LocationCircle.displayName = 'proto.apibuffers.LocationCircle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Location = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Location, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Location.displayName = 'proto.apibuffers.Location';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.LocationUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.LocationUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.LocationUpdate.displayName = 'proto.apibuffers.LocationUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.BasicUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.BasicUserInfo.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.BasicUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.BasicUserInfo.displayName = 'proto.apibuffers.BasicUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.ExtendedUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.ExtendedUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.ExtendedUserInfo.displayName = 'proto.apibuffers.ExtendedUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserError.displayName = 'proto.apibuffers.UserError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Dimension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Dimension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Dimension.displayName = 'proto.apibuffers.Dimension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Image = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Image, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Image.displayName = 'proto.apibuffers.Image';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Lottie = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Lottie, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Lottie.displayName = 'proto.apibuffers.Lottie';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Video = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Video, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Video.displayName = 'proto.apibuffers.Video';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Media = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.apibuffers.Media.oneofGroups_);
};
goog.inherits(proto.apibuffers.Media, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Media.displayName = 'proto.apibuffers.Media';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Date = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Date, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Date.displayName = 'proto.apibuffers.Date';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.DateRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.DateRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.DateRange.displayName = 'proto.apibuffers.DateRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Decimal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Decimal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Decimal.displayName = 'proto.apibuffers.Decimal';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.DeviceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.DeviceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.DeviceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.DeviceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    deviceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    appVersion: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    locale: jspb.Message.getFieldWithDefault(msg, 5, ""),
    deviceName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    advertisingId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.DeviceInfo}
 */
proto.apibuffers.DeviceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.DeviceInfo;
  return proto.apibuffers.DeviceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.DeviceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.DeviceInfo}
 */
proto.apibuffers.DeviceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.DeviceInfo.DeviceType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.DeviceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.DeviceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.DeviceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.DeviceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAppVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDeviceName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAdvertisingId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.DeviceInfo.DeviceType = {
  IOS: 0,
  ANDROID: 1,
  WEB: 2
};

/**
 * optional DeviceType type = 1;
 * @return {!proto.apibuffers.DeviceInfo.DeviceType}
 */
proto.apibuffers.DeviceInfo.prototype.getType = function() {
  return /** @type {!proto.apibuffers.DeviceInfo.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.DeviceInfo.DeviceType} value */
proto.apibuffers.DeviceInfo.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string device_id = 2;
 * @return {string}
 */
proto.apibuffers.DeviceInfo.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.DeviceInfo.prototype.setDeviceId = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string app_version = 3;
 * @return {string}
 */
proto.apibuffers.DeviceInfo.prototype.getAppVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.apibuffers.DeviceInfo.prototype.setAppVersion = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string time_zone = 4;
 * @return {string}
 */
proto.apibuffers.DeviceInfo.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.apibuffers.DeviceInfo.prototype.setTimeZone = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string locale = 5;
 * @return {string}
 */
proto.apibuffers.DeviceInfo.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.apibuffers.DeviceInfo.prototype.setLocale = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string device_name = 6;
 * @return {string}
 */
proto.apibuffers.DeviceInfo.prototype.getDeviceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.apibuffers.DeviceInfo.prototype.setDeviceName = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string advertising_id = 7;
 * @return {string}
 */
proto.apibuffers.DeviceInfo.prototype.getAdvertisingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.apibuffers.DeviceInfo.prototype.setAdvertisingId = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.LatLong.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.LatLong.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.LatLong} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LatLong.toObject = function(includeInstance, msg) {
  var f, obj = {
    latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.LatLong}
 */
proto.apibuffers.LatLong.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.LatLong;
  return proto.apibuffers.LatLong.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.LatLong} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.LatLong}
 */
proto.apibuffers.LatLong.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.LatLong.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.LatLong.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.LatLong} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LatLong.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.apibuffers.LatLong.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.apibuffers.LatLong.prototype.setLatitude = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.apibuffers.LatLong.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.apibuffers.LatLong.prototype.setLongitude = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Distance.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Distance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Distance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Distance.toObject = function(includeInstance, msg) {
  var f, obj = {
    distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    distanceType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Distance}
 */
proto.apibuffers.Distance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Distance;
  return proto.apibuffers.Distance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Distance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Distance}
 */
proto.apibuffers.Distance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDistance(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.Distance.DistanceType} */ (reader.readEnum());
      msg.setDistanceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Distance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Distance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Distance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Distance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getDistanceType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.Distance.DistanceType = {
  METERS: 0,
  KILOMETERS: 1
};

/**
 * optional float distance = 1;
 * @return {number}
 */
proto.apibuffers.Distance.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.apibuffers.Distance.prototype.setDistance = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional DistanceType distance_type = 2;
 * @return {!proto.apibuffers.Distance.DistanceType}
 */
proto.apibuffers.Distance.prototype.getDistanceType = function() {
  return /** @type {!proto.apibuffers.Distance.DistanceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.Distance.DistanceType} value */
proto.apibuffers.Distance.prototype.setDistanceType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.LocationCircle.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.LocationCircle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.LocationCircle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LocationCircle.toObject = function(includeInstance, msg) {
  var f, obj = {
    latLong: (f = msg.getLatLong()) && proto.apibuffers.LatLong.toObject(includeInstance, f),
    radius: (f = msg.getRadius()) && proto.apibuffers.Distance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.LocationCircle}
 */
proto.apibuffers.LocationCircle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.LocationCircle;
  return proto.apibuffers.LocationCircle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.LocationCircle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.LocationCircle}
 */
proto.apibuffers.LocationCircle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.apibuffers.LatLong;
      reader.readMessage(value,proto.apibuffers.LatLong.deserializeBinaryFromReader);
      msg.setLatLong(value);
      break;
    case 2:
      var value = new proto.apibuffers.Distance;
      reader.readMessage(value,proto.apibuffers.Distance.deserializeBinaryFromReader);
      msg.setRadius(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.LocationCircle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.LocationCircle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.LocationCircle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LocationCircle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatLong();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.apibuffers.LatLong.serializeBinaryToWriter
    );
  }
  f = message.getRadius();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.apibuffers.Distance.serializeBinaryToWriter
    );
  }
};


/**
 * optional LatLong lat_long = 1;
 * @return {?proto.apibuffers.LatLong}
 */
proto.apibuffers.LocationCircle.prototype.getLatLong = function() {
  return /** @type{?proto.apibuffers.LatLong} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.LatLong, 1));
};


/** @param {?proto.apibuffers.LatLong|undefined} value */
proto.apibuffers.LocationCircle.prototype.setLatLong = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.LocationCircle.prototype.clearLatLong = function() {
  this.setLatLong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.LocationCircle.prototype.hasLatLong = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Distance radius = 2;
 * @return {?proto.apibuffers.Distance}
 */
proto.apibuffers.LocationCircle.prototype.getRadius = function() {
  return /** @type{?proto.apibuffers.Distance} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.Distance, 2));
};


/** @param {?proto.apibuffers.Distance|undefined} value */
proto.apibuffers.LocationCircle.prototype.setRadius = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.LocationCircle.prototype.clearRadius = function() {
  this.setRadius(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.LocationCircle.prototype.hasRadius = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Location.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Location.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Location.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    latLong: (f = msg.getLatLong()) && proto.apibuffers.LatLong.toObject(includeInstance, f),
    countryCode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    city: jspb.Message.getFieldWithDefault(msg, 5, ""),
    suburb: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Location}
 */
proto.apibuffers.Location.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Location;
  return proto.apibuffers.Location.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Location}
 */
proto.apibuffers.Location.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.apibuffers.LatLong;
      reader.readMessage(value,proto.apibuffers.LatLong.deserializeBinaryFromReader);
      msg.setLatLong(value);
      break;
    case 4:
      var value = /** @type {!proto.apibuffers.CountryCode} */ (reader.readEnum());
      msg.setCountryCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuburb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Location.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Location.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Location.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLatLong();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.apibuffers.LatLong.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSuburb();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.Location.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.Location.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LatLong lat_long = 2;
 * @return {?proto.apibuffers.LatLong}
 */
proto.apibuffers.Location.prototype.getLatLong = function() {
  return /** @type{?proto.apibuffers.LatLong} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.LatLong, 2));
};


/** @param {?proto.apibuffers.LatLong|undefined} value */
proto.apibuffers.Location.prototype.setLatLong = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.Location.prototype.clearLatLong = function() {
  this.setLatLong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.Location.prototype.hasLatLong = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CountryCode country_code = 4;
 * @return {!proto.apibuffers.CountryCode}
 */
proto.apibuffers.Location.prototype.getCountryCode = function() {
  return /** @type {!proto.apibuffers.CountryCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.apibuffers.CountryCode} value */
proto.apibuffers.Location.prototype.setCountryCode = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.apibuffers.Location.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.apibuffers.Location.prototype.setCity = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string suburb = 6;
 * @return {string}
 */
proto.apibuffers.Location.prototype.getSuburb = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.apibuffers.Location.prototype.setSuburb = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.LocationUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.LocationUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.LocationUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LocationUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    locationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.LocationUpdate}
 */
proto.apibuffers.LocationUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.LocationUpdate;
  return proto.apibuffers.LocationUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.LocationUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.LocationUpdate}
 */
proto.apibuffers.LocationUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.LocationUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.LocationUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.LocationUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LocationUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string location_id = 1;
 * @return {string}
 */
proto.apibuffers.LocationUpdate.prototype.getLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.LocationUpdate.prototype.setLocationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.BasicUserInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.BasicUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.BasicUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.BasicUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.BasicUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileImage: (f = msg.getProfileImage()) && proto.apibuffers.Image.toObject(includeInstance, f),
    profileImagesList: jspb.Message.toObjectList(msg.getProfileImagesList(),
    proto.apibuffers.Image.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.BasicUserInfo}
 */
proto.apibuffers.BasicUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.BasicUserInfo;
  return proto.apibuffers.BasicUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.BasicUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.BasicUserInfo}
 */
proto.apibuffers.BasicUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = new proto.apibuffers.Image;
      reader.readMessage(value,proto.apibuffers.Image.deserializeBinaryFromReader);
      msg.setProfileImage(value);
      break;
    case 4:
      var value = new proto.apibuffers.Image;
      reader.readMessage(value,proto.apibuffers.Image.deserializeBinaryFromReader);
      msg.addProfileImages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.BasicUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.BasicUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.BasicUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.BasicUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.apibuffers.Image.serializeBinaryToWriter
    );
  }
  f = message.getProfileImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.apibuffers.Image.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.BasicUserInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.BasicUserInfo.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.apibuffers.BasicUserInfo.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.BasicUserInfo.prototype.setUserName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Image profile_image = 3;
 * @return {?proto.apibuffers.Image}
 */
proto.apibuffers.BasicUserInfo.prototype.getProfileImage = function() {
  return /** @type{?proto.apibuffers.Image} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.Image, 3));
};


/** @param {?proto.apibuffers.Image|undefined} value */
proto.apibuffers.BasicUserInfo.prototype.setProfileImage = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.BasicUserInfo.prototype.clearProfileImage = function() {
  this.setProfileImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.BasicUserInfo.prototype.hasProfileImage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Image profile_images = 4;
 * @return {!Array<!proto.apibuffers.Image>}
 */
proto.apibuffers.BasicUserInfo.prototype.getProfileImagesList = function() {
  return /** @type{!Array<!proto.apibuffers.Image>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.Image, 4));
};


/** @param {!Array<!proto.apibuffers.Image>} value */
proto.apibuffers.BasicUserInfo.prototype.setProfileImagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.apibuffers.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.Image}
 */
proto.apibuffers.BasicUserInfo.prototype.addProfileImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.apibuffers.Image, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.BasicUserInfo.prototype.clearProfileImagesList = function() {
  this.setProfileImagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.ExtendedUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.ExtendedUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.ExtendedUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.ExtendedUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto.apibuffers.BasicUserInfo.toObject(includeInstance, f),
    nationality: jspb.Message.getFieldWithDefault(msg, 2, 0),
    verified: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    following: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    onlineStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    distance: (f = msg.getDistance()) && proto.apibuffers.Distance.toObject(includeInstance, f),
    statusId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    deactivated: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    isGuest: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.ExtendedUserInfo}
 */
proto.apibuffers.ExtendedUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.ExtendedUserInfo;
  return proto.apibuffers.ExtendedUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.ExtendedUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.ExtendedUserInfo}
 */
proto.apibuffers.ExtendedUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.apibuffers.BasicUserInfo;
      reader.readMessage(value,proto.apibuffers.BasicUserInfo.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.CountryCode} */ (reader.readEnum());
      msg.setNationality(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFollowing(value);
      break;
    case 5:
      var value = /** @type {!proto.apibuffers.ExtendedUserInfo.OnlineStatus} */ (reader.readEnum());
      msg.setOnlineStatus(value);
      break;
    case 6:
      var value = new proto.apibuffers.Distance;
      reader.readMessage(value,proto.apibuffers.Distance.deserializeBinaryFromReader);
      msg.setDistance(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusId(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeactivated(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGuest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.ExtendedUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.ExtendedUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.ExtendedUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.ExtendedUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.apibuffers.BasicUserInfo.serializeBinaryToWriter
    );
  }
  f = message.getNationality();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFollowing();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOnlineStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDistance();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.apibuffers.Distance.serializeBinaryToWriter
    );
  }
  f = message.getStatusId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDeactivated();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIsGuest();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.ExtendedUserInfo.OnlineStatus = {
  NONE: 0,
  RECENT: 1,
  NOW: 2
};

/**
 * optional BasicUserInfo user = 1;
 * @return {?proto.apibuffers.BasicUserInfo}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getUser = function() {
  return /** @type{?proto.apibuffers.BasicUserInfo} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.BasicUserInfo, 1));
};


/** @param {?proto.apibuffers.BasicUserInfo|undefined} value */
proto.apibuffers.ExtendedUserInfo.prototype.setUser = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.ExtendedUserInfo.prototype.clearUser = function() {
  this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.ExtendedUserInfo.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CountryCode nationality = 2;
 * @return {!proto.apibuffers.CountryCode}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getNationality = function() {
  return /** @type {!proto.apibuffers.CountryCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.CountryCode} value */
proto.apibuffers.ExtendedUserInfo.prototype.setNationality = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool verified = 3;
 * @return {boolean}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.apibuffers.ExtendedUserInfo.prototype.setVerified = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool following = 4;
 * @return {boolean}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getFollowing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.apibuffers.ExtendedUserInfo.prototype.setFollowing = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional OnlineStatus online_Status = 5;
 * @return {!proto.apibuffers.ExtendedUserInfo.OnlineStatus}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getOnlineStatus = function() {
  return /** @type {!proto.apibuffers.ExtendedUserInfo.OnlineStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.apibuffers.ExtendedUserInfo.OnlineStatus} value */
proto.apibuffers.ExtendedUserInfo.prototype.setOnlineStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Distance distance = 6;
 * @return {?proto.apibuffers.Distance}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getDistance = function() {
  return /** @type{?proto.apibuffers.Distance} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.Distance, 6));
};


/** @param {?proto.apibuffers.Distance|undefined} value */
proto.apibuffers.ExtendedUserInfo.prototype.setDistance = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.ExtendedUserInfo.prototype.clearDistance = function() {
  this.setDistance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.ExtendedUserInfo.prototype.hasDistance = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string status_id = 7;
 * @return {string}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getStatusId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.apibuffers.ExtendedUserInfo.prototype.setStatusId = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool deactivated = 8;
 * @return {boolean}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getDeactivated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.apibuffers.ExtendedUserInfo.prototype.setDeactivated = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool is_guest = 9;
 * @return {boolean}
 */
proto.apibuffers.ExtendedUserInfo.prototype.getIsGuest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.apibuffers.ExtendedUserInfo.prototype.setIsGuest = function(value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserError.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserError.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserError}
 */
proto.apibuffers.UserError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserError;
  return proto.apibuffers.UserError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserError}
 */
proto.apibuffers.UserError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.apibuffers.UserError.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserError.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.apibuffers.UserError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.UserError.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Dimension.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Dimension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Dimension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Dimension.toObject = function(includeInstance, msg) {
  var f, obj = {
    height: jspb.Message.getFieldWithDefault(msg, 1, 0),
    width: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Dimension}
 */
proto.apibuffers.Dimension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Dimension;
  return proto.apibuffers.Dimension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Dimension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Dimension}
 */
proto.apibuffers.Dimension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHeight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWidth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Dimension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Dimension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Dimension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Dimension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 height = 1;
 * @return {number}
 */
proto.apibuffers.Dimension.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.apibuffers.Dimension.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 width = 2;
 * @return {number}
 */
proto.apibuffers.Dimension.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.apibuffers.Dimension.prototype.setWidth = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Image.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Image.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Image.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    size: (f = msg.getSize()) && proto.apibuffers.Dimension.toObject(includeInstance, f),
    pb_class: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Image}
 */
proto.apibuffers.Image.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Image;
  return proto.apibuffers.Image.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Image}
 */
proto.apibuffers.Image.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = new proto.apibuffers.Dimension;
      reader.readMessage(value,proto.apibuffers.Dimension.deserializeBinaryFromReader);
      msg.setSize(value);
      break;
    case 3:
      var value = /** @type {!proto.apibuffers.Image.Class} */ (reader.readEnum());
      msg.setClass(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Image.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Image.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Image.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSize();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.apibuffers.Dimension.serializeBinaryToWriter
    );
  }
  f = message.getClass();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.Image.Class = {
  UNKNOWN: 0,
  RAW: 1,
  THUMBNAIL: 2,
  MEDIUM: 3,
  SMALL: 4,
  MEDIUM_SQUARE: 5,
  SMALL_SQUARE: 6
};

/**
 * optional string url = 1;
 * @return {string}
 */
proto.apibuffers.Image.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.Image.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Dimension size = 2;
 * @return {?proto.apibuffers.Dimension}
 */
proto.apibuffers.Image.prototype.getSize = function() {
  return /** @type{?proto.apibuffers.Dimension} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.Dimension, 2));
};


/** @param {?proto.apibuffers.Dimension|undefined} value */
proto.apibuffers.Image.prototype.setSize = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.Image.prototype.clearSize = function() {
  this.setSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.Image.prototype.hasSize = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Class class = 3;
 * @return {!proto.apibuffers.Image.Class}
 */
proto.apibuffers.Image.prototype.getClass = function() {
  return /** @type {!proto.apibuffers.Image.Class} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.apibuffers.Image.Class} value */
proto.apibuffers.Image.prototype.setClass = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Lottie.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Lottie.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Lottie} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Lottie.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Lottie}
 */
proto.apibuffers.Lottie.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Lottie;
  return proto.apibuffers.Lottie.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Lottie} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Lottie}
 */
proto.apibuffers.Lottie.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Lottie.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Lottie.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Lottie} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Lottie.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.apibuffers.Lottie.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.Lottie.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Video.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Video.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Video} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Video.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Video}
 */
proto.apibuffers.Video.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Video;
  return proto.apibuffers.Video.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Video} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Video}
 */
proto.apibuffers.Video.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Video.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Video.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Video} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Video.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.apibuffers.Video.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.Video.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.apibuffers.Media.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.apibuffers.Media.MediaCase = {
  MEDIA_NOT_SET: 0,
  IMAGE: 4,
  VIDEO: 5
};

/**
 * @return {proto.apibuffers.Media.MediaCase}
 */
proto.apibuffers.Media.prototype.getMediaCase = function() {
  return /** @type {proto.apibuffers.Media.MediaCase} */(jspb.Message.computeOneofCase(this, proto.apibuffers.Media.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Media.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Media.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Media} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Media.toObject = function(includeInstance, msg) {
  var f, obj = {
    image: (f = msg.getImage()) && proto.apibuffers.Image.toObject(includeInstance, f),
    video: (f = msg.getVideo()) && proto.apibuffers.Video.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Media}
 */
proto.apibuffers.Media.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Media;
  return proto.apibuffers.Media.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Media} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Media}
 */
proto.apibuffers.Media.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = new proto.apibuffers.Image;
      reader.readMessage(value,proto.apibuffers.Image.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 5:
      var value = new proto.apibuffers.Video;
      reader.readMessage(value,proto.apibuffers.Video.deserializeBinaryFromReader);
      msg.setVideo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Media.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Media.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Media} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Media.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.apibuffers.Image.serializeBinaryToWriter
    );
  }
  f = message.getVideo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.apibuffers.Video.serializeBinaryToWriter
    );
  }
};


/**
 * optional Image image = 4;
 * @return {?proto.apibuffers.Image}
 */
proto.apibuffers.Media.prototype.getImage = function() {
  return /** @type{?proto.apibuffers.Image} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.Image, 4));
};


/** @param {?proto.apibuffers.Image|undefined} value */
proto.apibuffers.Media.prototype.setImage = function(value) {
  jspb.Message.setOneofWrapperField(this, 4, proto.apibuffers.Media.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.Media.prototype.clearImage = function() {
  this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.Media.prototype.hasImage = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Video video = 5;
 * @return {?proto.apibuffers.Video}
 */
proto.apibuffers.Media.prototype.getVideo = function() {
  return /** @type{?proto.apibuffers.Video} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.Video, 5));
};


/** @param {?proto.apibuffers.Video|undefined} value */
proto.apibuffers.Media.prototype.setVideo = function(value) {
  jspb.Message.setOneofWrapperField(this, 5, proto.apibuffers.Media.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.Media.prototype.clearVideo = function() {
  this.setVideo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.Media.prototype.hasVideo = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Date.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Date.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Date} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Date.toObject = function(includeInstance, msg) {
  var f, obj = {
    year: jspb.Message.getFieldWithDefault(msg, 1, 0),
    month: jspb.Message.getFieldWithDefault(msg, 2, 0),
    day: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Date}
 */
proto.apibuffers.Date.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Date;
  return proto.apibuffers.Date.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Date} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Date}
 */
proto.apibuffers.Date.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonth(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Date.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Date.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Date} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Date.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getYear();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMonth();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDay();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 year = 1;
 * @return {number}
 */
proto.apibuffers.Date.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.apibuffers.Date.prototype.setYear = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 month = 2;
 * @return {number}
 */
proto.apibuffers.Date.prototype.getMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.apibuffers.Date.prototype.setMonth = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 day = 3;
 * @return {number}
 */
proto.apibuffers.Date.prototype.getDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.apibuffers.Date.prototype.setDay = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.DateRange.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.DateRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.DateRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.DateRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromdate: (f = msg.getFromdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    todate: (f = msg.getTodate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.DateRange}
 */
proto.apibuffers.DateRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.DateRange;
  return proto.apibuffers.DateRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.DateRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.DateRange}
 */
proto.apibuffers.DateRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFromdate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTodate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.DateRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.DateRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.DateRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.DateRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromdate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTodate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp fromDate = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.apibuffers.DateRange.prototype.getFromdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.apibuffers.DateRange.prototype.setFromdate = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.DateRange.prototype.clearFromdate = function() {
  this.setFromdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.DateRange.prototype.hasFromdate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp toDate = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.apibuffers.DateRange.prototype.getTodate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.apibuffers.DateRange.prototype.setTodate = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.DateRange.prototype.clearTodate = function() {
  this.setTodate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.DateRange.prototype.hasTodate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Decimal.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Decimal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Decimal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Decimal.toObject = function(includeInstance, msg) {
  var f, obj = {
    scale: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Decimal}
 */
proto.apibuffers.Decimal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Decimal;
  return proto.apibuffers.Decimal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Decimal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Decimal}
 */
proto.apibuffers.Decimal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScale(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Decimal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Decimal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Decimal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Decimal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScale();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 scale = 1;
 * @return {number}
 */
proto.apibuffers.Decimal.prototype.getScale = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.apibuffers.Decimal.prototype.setScale = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 value = 2;
 * @return {number}
 */
proto.apibuffers.Decimal.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.apibuffers.Decimal.prototype.setValue = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.apibuffers.FriendshipStatus = {
  NOT_FRIEND: 0,
  DECLINED: 1,
  FRIEND: 2,
  PENDING: 3,
  REQUESTED: 4,
  BLOCKED: 5
};

/**
 * @enum {number}
 */
proto.apibuffers.CountryCode = {
  UNKNOWN_COUNTRYCODE: 0,
  AX: 1,
  AL: 2,
  DZ: 3,
  AS: 4,
  AD: 5,
  AO: 6,
  AI: 7,
  AQ: 8,
  AG: 9,
  AR: 10,
  AM: 11,
  AW: 12,
  AU: 13,
  AT: 14,
  AZ: 15,
  BS: 16,
  BH: 17,
  BD: 18,
  BB: 19,
  BY: 20,
  BE: 21,
  BZ: 22,
  BJ: 23,
  BM: 24,
  BT: 25,
  BO: 26,
  BQ: 27,
  BA: 28,
  BW: 29,
  BV: 30,
  BR: 31,
  IO: 32,
  BN: 33,
  BG: 34,
  BF: 35,
  BI: 36,
  KH: 37,
  CM: 38,
  CA: 39,
  CV: 40,
  KY: 41,
  CF: 42,
  TD: 43,
  CL: 44,
  CN: 45,
  CX: 46,
  CC: 47,
  CO: 48,
  KM: 49,
  CG: 50,
  CD: 51,
  CK: 52,
  CR: 53,
  CI: 54,
  HR: 55,
  CU: 56,
  CW: 57,
  CY: 58,
  CZ: 59,
  DK: 60,
  DJ: 61,
  DM: 62,
  DO: 63,
  EC: 64,
  EG: 65,
  SV: 66,
  GQ: 67,
  ER: 68,
  EE: 69,
  ET: 70,
  FK: 71,
  FO: 72,
  FJ: 73,
  FI: 74,
  FR: 75,
  GF: 76,
  PF: 77,
  TF: 78,
  GA: 79,
  GM: 80,
  GE: 81,
  DE: 82,
  GH: 83,
  GI: 84,
  GR: 85,
  GL: 86,
  GD: 87,
  GP: 88,
  GU: 89,
  GT: 90,
  GG: 91,
  GN: 92,
  GW: 93,
  GY: 94,
  HT: 95,
  HM: 96,
  VA: 97,
  HN: 98,
  HK: 99,
  HU: 100,
  IS: 101,
  IN: 102,
  ID: 103,
  IR: 104,
  IQ: 105,
  IE: 106,
  IM: 107,
  IL: 108,
  IT: 109,
  JM: 110,
  JP: 111,
  JE: 112,
  JO: 113,
  KZ: 114,
  KE: 115,
  KI: 116,
  KP: 117,
  KR: 118,
  KW: 119,
  KG: 120,
  LA: 121,
  LV: 122,
  LB: 123,
  LS: 124,
  LR: 125,
  LY: 126,
  LI: 127,
  LT: 128,
  LU: 129,
  MO: 130,
  MK: 131,
  MG: 132,
  MW: 133,
  MY: 134,
  MV: 135,
  ML: 136,
  MT: 137,
  MH: 138,
  MQ: 139,
  MR: 140,
  MU: 141,
  YT: 142,
  MX: 143,
  FM: 144,
  MD: 145,
  MC: 146,
  MN: 147,
  ME: 148,
  MS: 149,
  MA: 150,
  MZ: 151,
  MM: 152,
  NA: 153,
  NR: 154,
  NP: 155,
  NL: 156,
  NC: 157,
  NZ: 158,
  NI: 159,
  NE: 160,
  NG: 161,
  NU: 162,
  NF: 163,
  MP: 164,
  NO: 165,
  OM: 166,
  PK: 167,
  PW: 168,
  PS: 169,
  PA: 170,
  PG: 171,
  PY: 172,
  PE: 173,
  PH: 174,
  PN: 175,
  PL: 176,
  PT: 177,
  PR: 178,
  QA: 179,
  RE: 180,
  RO: 181,
  RU: 182,
  RW: 183,
  BL: 184,
  SH: 185,
  KN: 186,
  LC: 187,
  MF: 188,
  PM: 189,
  VC: 190,
  WS: 191,
  SM: 192,
  ST: 193,
  SA: 194,
  SN: 195,
  RS: 196,
  SC: 197,
  SL: 198,
  SG: 199,
  SX: 200,
  SK: 201,
  SI: 202,
  SB: 203,
  SO: 204,
  ZA: 205,
  GS: 206,
  SS: 207,
  ES: 208,
  LK: 209,
  SD: 210,
  SR: 211,
  SJ: 212,
  SZ: 213,
  SE: 214,
  CH: 215,
  SY: 216,
  TW: 217,
  TJ: 218,
  TZ: 219,
  TH: 220,
  TL: 221,
  TG: 222,
  TK: 223,
  TO: 224,
  TT: 225,
  TN: 226,
  TR: 227,
  TM: 228,
  TC: 229,
  TV: 230,
  UG: 231,
  UA: 232,
  AE: 233,
  GB: 234,
  US: 235,
  UM: 236,
  UY: 237,
  UZ: 238,
  VU: 239,
  VE: 240,
  VN: 241,
  VG: 242,
  VI: 243,
  WF: 244,
  EH: 245,
  YE: 246,
  ZM: 247,
  ZW: 248,
  AF: 249,
  WITHHELD_COUNTRY_CODE: 999
};

goog.object.extend(exports, proto.apibuffers);
